import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import { AppShell } from "./components/AppShell";
import { RequireAuth } from "./components/RequireAuth";
import { ActivityPage } from "./pages/ActivityPage";
import { BatchPage } from "./pages/BatchPage";
import { DashboardPage } from "./pages/DashboardPage";
import { InventoryDetailPage } from "./pages/InventoryDetailPage";
import { InventoryListPage } from "./pages/InventoryListPage";
import { LocationsPage } from "./pages/LocationsPage";
import { LoginPage } from "./pages/LoginPage";
import { NewInventoryPage } from "./pages/NewInventoryPage";
import { OperationsPage } from "./pages/OperationsPage";
import { ProvisionPage } from "./pages/ProvisionPage";
import { SettingsPage } from "./pages/SettingsPage";
import { TagLandingPage } from "./pages/TagLandingPage";

function AuthenticatedLayout() {
  return (
    <RequireAuth>
      <AppShell>
        <Outlet />
      </AppShell>
    </RequireAuth>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/tag/:token" element={<TagLandingPage />} />
          <Route element={<AuthenticatedLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/inventory" element={<InventoryListPage />} />
            <Route path="/inventory/new" element={<NewInventoryPage />} />
            <Route path="/inventory/:id" element={<InventoryDetailPage />} />
            <Route path="/provision" element={<ProvisionPage />} />
            <Route path="/batch" element={<BatchPage />} />
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/operations" element={<OperationsPage />} />
            <Route path="/activity" element={<ActivityPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

